module.exports = __webpack_public_path__ + "img/pillbadge-sample-1.50cc500c.png";